import type { FaireProductEntity } from "../../entity_types/product";

export const p_xtuf37qb5k: FaireProductEntity = {
  token: "p_xtuf37qb5k",
  type: "product",
  name: "Fanta Cream Soda Fruit Punch 320ml (Thailand)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl: "https://cdn.faire.com/fastly/b0cfcb6c78f39e1e14aa78af2af1c93379323729ecf06b77bc81d9672ff50c7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7f39fb43990897518cd748235cc5308ccf41e7164a45e1d20530bbb083be46e.jpeg"
  ],
  priceDollars: 3.05,
  description: "Fanta Fruit Punch 320 mL from Thailand is a tropical delight packed into a single can. This carbonated beverage blends the refreshing fizz of Fanta with a burst of exotic fruit flavors, including hints of pineapple, mango, and guava typical of Thailand's tropical bounty. Its vibrant color mirrors its bold and fruity taste, making it a perfect choice for those seeking a taste of paradise in a convenient 320 mL serving, ideal for any occasion.\n",
  tags: [],
  msrpDollars: 5.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:56.628Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
